import { render, staticRenderFns } from "./LowerThird.vue?vue&type=template&id=f006835a&scoped=true&"
import script from "./LowerThird.vue?vue&type=script&lang=js&"
export * from "./LowerThird.vue?vue&type=script&lang=js&"
import style0 from "./LowerThird.vue?vue&type=style&index=0&id=f006835a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f006835a",
  null
  
)

export default component.exports